// extracted by mini-css-extract-plugin
export default {"PaginationContainer":"StyledPagination_PaginationContainer__-G3Xo"};